export enum PaymentFlowType {
  deposit = 'deposit',
  transfer = 'transfer',
  withdraw = 'withdraw',
}
